export default __webpack_public_path__ + "static/media/OrganiseAndDiarise.139854c7.jpg";